import Link from 'next/link';
import { useRouter } from 'next/router';
import { logger } from '@zep/core-logger';
import type { QuizsetRankingSummaryRes } from '@/api/gen/_model/quizsetRankingSummaryRes';
import { createZepetoImageMonitor } from '@/shared/utils/zepetoImageMonitor';
import { cn } from '@/utils/tailwind.util';
export const FeaturedQuizCard = (props: QuizsetRankingSummaryRes & {
  schoolType: string;
  period: string;
}) => {
  const router = useRouter();
  const isPublicPage = router.pathname === '/public';
  const isQuizDetailPage = router.pathname === '/quiz/[id]';
  const handleClick = () => {
    logger.track('enter_detail_featured', {
      location: isPublicPage ? 'public' : isQuizDetailPage ? 'quiz-detail' : 'unknown',
      id: props.quizsetId,
      period: props.period,
      schoolType: props.schoolType
    });
  };
  return <Link className={'group flex h-[61px]  w-full flex-row items-center justify-between gap-sm self-stretch rounded-sm px-2xs hover:bg-neutral'} href={`/quiz/${props.quizsetId}`} target={'_self'} onClick={handleClick} data-sentry-element="Link" data-sentry-component="FeaturedQuizCard" data-sentry-source-file="FeaturedQuizCard.tsx">
      <div className={'flex size-full flex-1 flex-row items-center gap-xs overflow-hidden py-sm'}>
        <div className={'min-w-[18px] text-body-lg-bold text-assistive'}>
          {props.order}
        </div>
        <span className={'line-clamp-2 max-w-[150px] text-body-sm-semibold text-default'}>
          {props.title}
        </span>
      </div>
      <div className={'flex min-h-[40.54px] min-w-[62px] items-center justify-center overflow-hidden rounded-xs'}>
        <img className={cn('shrink rounded-xs w-[62px] h-[40.54px] transition-transform duration-300 ease-in-out', 'group-hover:scale-110')} src={props.thumbnailImage} alt={props.title} {...createZepetoImageMonitor('featured-list')} />
      </div>
    </Link>;
};